
const EN = "qwertyuiop[]asdfghjkl;'zxcvbnm,.`";
const RU = 'йцукенгшщзхъфывапролджэячсмитьбюё';

const EN_TO_RU = new Map<string, string>();
const RU_TO_EN = new Map<string, string>();
for (let i = 0; i < EN.length; i += 1) {
  EN_TO_RU.set(EN[i], RU[i]);
  RU_TO_EN.set(RU[i], EN[i]);
}

function convert(text: string, map: Map<string, string>): string {
  let out = '';
  for (const ch of text) {
    const lower = ch.toLowerCase();
    const hit = map.get(lower);
    if (hit == null) out += ch;
    else out += ch === lower ? hit : hit.toUpperCase();
  }
  return out;
}

export function swapLayout(text: string): string | null {
  let latin = 0;
  let cyrillic = 0;
  for (const ch of text) {
    if (/[a-z]/i.test(ch)) latin += 1;
    else if (/[а-яё]/i.test(ch)) cyrillic += 1;
  }
  if (latin === 0 && cyrillic === 0) return null;
  const swapped = latin >= cyrillic ? convert(text, EN_TO_RU) : convert(text, RU_TO_EN);
  return swapped === text ? null : swapped;
}
